<template>
    <div class="searchseat-wrapper">
        <div style="min-height:100vh" class="flex flex-column">
            <custom-header>
                <img class="banner" :src="(winWidth > 768 ? meetingInfo.banner_pc : meetingInfo.banner_h5) | urlFilter" alt="">
                <div v-if="meetingInfo.is_open_search == 1" class="max-width" style="margin:20px auto;">
                    <a-input-search size="large" ref="inputElem" v-model="search_name" placeholder="输入姓名查找座位" @pressEnter="handleSearchEvent" @search="handleSearchEvent">
                        <i class="iconfont icon-sousuo-sousuo" slot="enterButton"></i>
                    </a-input-search>
                </div>
            </custom-header>
            <!-- 开启查询功能 -->
            <template v-if="meetingInfo.is_open_search == 1">
                <div v-if="isResult" class="layout-content flex flex-column">
                    <div v-if="dataList.length" class="search-list">
                        <div @click="handleRouterJump(item,index)" v-for="(item,index) in dataList" :class="{'curr-selected' : index == selectIndex}" :key="index" class="search-item flex y-center max-width">
                            <div>
                                <h2 style="line-height:1;" class="fs16">
                                    <template v-if="item.hall_name">
                                        {{item.hall_name}} 
                                    </template> 
                                    <template v-if="item.area_name">
                                        - {{item.area_name}}
                                    </template> 
                                    <!-- 是否显示具体座位 -->
                                    <template v-if="item.is_seat == 1">
                                        <template v-if="item.row_name">
                                            - {{item.row_name}}
                                        </template>   
                                        <template v-if="item.desk_name">
                                            - {{item.desk_name}}
                                        </template>   
                                    </template> 
                                </h2>
                                <div class="flex x-left color999"> 
                                    <div class="row-1 flex-item">地址：{{item.hall_desc}}</div>
                                    <div class="ml10">时间：{{item.hall_date.substr(0,10)}}</div>
                                </div>
                                <div class="color999">
                                    {{item.name}}   {{item.mobile.substr(0,3) + '****' + item.mobile.substr(7,11)}}
                                </div>
                            </div>
                            <i class="iconfont icon-right_light-copy"></i>
                        </div>
                    </div>
                    <div v-else class="t-c">
                        <div v-if="empty.message" class="result-t" v-html="empty.message"></div>
                        <img v-if="empty.tip_pic" style="max-width:100%;" :src="empty.tip_pic | urlFilter">
                    </div>
                    <iframe v-if="seatMap" class="mt15 flex-item" style="min-height:350px;width:100%;padding:0 15px;" :src="seatMap" frameborder="0">
                    </iframe>
                </div>
            </template>
            <div v-else class="flex-item">
                <p class="mt30 t-c fs18" style="color:#f00;">座位查询未开启</p>
            </div>
            <div class="container" style="background: rgba(0, 0, 0, 0.2);color: #fff;line-height:1.5;padding:10px 0;text-align:center">
                <div>技术支持<a target="_blank" href="https://work.weixin.qq.com/kfid/kfc523692103df210d9" style="margin-left:5px;">
                        <img src="https://www.medmeeting.org/Content/images/minilogo.png" alt="" width="20" style="margin-right:5px;position:relative;top:2px;">美迪康会务通</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import customHeader from '@/components/layout/custom-head.vue';
import { urlFilter } from "@/utils/filter.js";
import { wexinShare } from "@/utils/wechatShare";
import { mapState } from 'vuex';
export default {
    name: "Searchseat",
    components: { customHeader },
    props: {

    },
    data() {
        return {
            dataList: [],
            selectIndex:'',
            isResult: false,
            empty: {
                message: '',
                tip_pic: '',
            },
            search_name:'', // 搜索name,
            seatMap: '', // 座位图
            winWidth:(() => {
                return window.innerWidth;
            })()
        }
    },
    computed:{
        ...mapState(['meetingInfo']),
    },
    methods: {
        handleSearchEvent(e) {
            this.isResult = false;
            this.seatMap = '';
            e = e?.target?.value || e;
            if(!e){
                this.$message.error("请输入姓名查找座位");
                return false;
            }
            this.$request.post({ url: 'search', data: { name: e } }).then(res => {
                if (res && res.code == 100000) {
                    if (!Array.isArray(res.data)) {
                        this.dataList = [];
                        // 搜索不到内容提示信息
                        this.empty.message = res.message_tip || '没有查找到 “<span style="color:#f00">' + e + '</span>” 此人的座位';
                        this.empty.tip_pic = res.message_img;
                    } else {
                        let result = [];
                        let dataList = res.data || [];
                        dataList.forEach(it => {
                            // 是否显示区域为分配人员
                            if((!it.is_no_seat || it.is_no_seat == 0) && !it.desk_name){

                            }else{
                                result.push(it);
                            }
                        });
                        this.dataList = result;
                        this.handleRouterJump(this.dataList[0],0);
                    }
                }
            }).finally(() => {
                this.isResult = true;
            })
        },

        handleRouterJump(obj,index) {
            // 不显示具体座位
            if(obj.is_seat != 1 || !obj.desk_name){
                this.seatMap = '';
                return false;
            }
            this.selectIndex = index;
            const { meeting_id } = this.$route.params;
            let winHref = window.location.href.split('#')[0];
            if (obj) {
                let { hall_id, person_id } = obj;
                this.seatMap = `${winHref}?time=${+(new Date())}#/preview/${meeting_id}?hall_id=${hall_id}&person_id=${person_id}`;
            }

        },
        getHallData(){
            this.$request.post({ url: "getHall" }).then(res => {
                if(res.data.length){
                    let { meeting_id,hall_id } = this.$route.params;
                    if(!hall_id){
                        hall_id = res.data[res.data.length-1]?.id;
                    }
                    let winHref = window.location.href.split('#')[0];
                    // 是否设置允许查看他人,允许的情况下默认显示座位图
                    if(this.meetingInfo.is_show_other == 1){
                        this.seatMap = `${winHref}?time=${+(new Date())}#/preview/${meeting_id}?hall_id=${hall_id}`;
                    }
                    this.isResult = true;
                }
            })
        },
        weixinShare() {
            let url = window.location.href.split('#')[0];
            // let url = encodeURIComponent(window.location.href.split('#')[0]);
            this.$request.post({url:'getWxJsApi',data:{appId: this.meetingInfo.app_id,url},costom:{hideModal:true}}).then(res => {
                let { appId, nonceStr, timestamp, signature } = res;
                let obj = {
                    appId,
                    nonceStr,
                    signature,
                    timestamp,
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
                };
                // //分享数据，这段主要是为了在hash模式下分享出去的链接不被浏览器截取，保证完全把链接分享出去
                let shareData = {
                    title: this.meetingInfo.cover_title, // 分享标题
                    desc: this.meetingInfo.cover_describe,
                    link: window.location.href,
                    imgUrl: urlFilter(this.meetingInfo.cover_img,750) // 分享图标
                };
                //引用
                wexinShare(obj, shareData);
            }).catch(err => {
              console.log(err);
            })
        },
    },
    created(){
        let { name } = this.$route.query;
        if(name){
            name = decodeURI(name);
            this.search_name = name;
            this.handleSearchEvent(name);
        }else{
            this.getHallData();
        }
       
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.inputElem.focus();
        })
        this.weixinShare();
    },
}
</script>

<style lang="less" scoped>
.banner{
    display: block;
    max-width:100%;
    margin:0 auto;
}
.iframe-fullscreen{
    position: fixed!important;
    left:0;
    top:-15px;
    z-index: 999;
    width:100%;
    height:100%;
    padding:0!important;
}
.max-width {
    max-width: 800px;
    margin: 0 auto;
}

.layout-content {
    min-height:calc(100vh - 190px);
    background: #f5f6f9;
    width: 100%;
    overflow: auto;
}

.searchseat-wrapper {
    /deep/.ant-input-group-wrapper {
        background: #f5f6f9;
        border: 0;
        padding: 0 10px;
        border-radius: 50px;
        overflow: hidden;
        .ant-input {
            background: transparent;
            border: 0;
            outline: none;
            &:focus {
                box-shadow: none;
            }
        }
        .ant-input-group-addon {
            background: transparent;
            .ant-btn {
                background: transparent;
                color: #666;
                border: 0;
                &:after {
                    opacity: 0;
                }
            }
        }
    }
}

.search-item {
    background-color: #fff;
    padding:15px 20px;
    margin-top: 15px;
    border-radius: 5px;
    border:1px solid #fff;
    &.curr-selected{
        border-color:@theme;
    }
    cursor: pointer;
    h2 {
        color: @danger;
    }
}

.result-t {
    padding: 15px 0;
    color: #8598b3;
    font-size: 16px;
}

@media screen and (max-width:768px) {
    .banner{
        margin: -15px 0 0 -15px;
        width: calc(100% + 30px);
        max-width: inherit;
    }
    .layout-content {
        min-height:calc(100vh - 170px);
    }
    .search-list {
        padding:0 10px;
        .search-item {
            margin-top: 10px;
            padding: 15px;
        }
    }
}
</style>